/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsightfulnessCriterion } from './InsightfulnessCriterion';
import {
  InsightfulnessCriterionFromJSON,
  InsightfulnessCriterionFromJSONTyped,
  InsightfulnessCriterionToJSON,
} from './InsightfulnessCriterion';

/**
 *
 * @export
 * @interface PaginatedInsightfulnessCriterionList
 */
export interface PaginatedInsightfulnessCriterionList {
  /**
   *
   * @type {number}
   * @memberof PaginatedInsightfulnessCriterionList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedInsightfulnessCriterionList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedInsightfulnessCriterionList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<InsightfulnessCriterion>}
   * @memberof PaginatedInsightfulnessCriterionList
   */
  results: Array<InsightfulnessCriterion>;
}

/**
 * Check if a given object implements the PaginatedInsightfulnessCriterionList interface.
 */
export function instanceOfPaginatedInsightfulnessCriterionList(
  value: object,
): value is PaginatedInsightfulnessCriterionList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedInsightfulnessCriterionListFromJSON(json: any): PaginatedInsightfulnessCriterionList {
  return PaginatedInsightfulnessCriterionListFromJSONTyped(json, false);
}

export function PaginatedInsightfulnessCriterionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedInsightfulnessCriterionList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(InsightfulnessCriterionFromJSON),
  };
}

export function PaginatedInsightfulnessCriterionListToJSON(value?: PaginatedInsightfulnessCriterionList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(InsightfulnessCriterionToJSON),
  };
}
